import { DialogPlugin, MessagePlugin, message } from 'tdesign-react';
const duration = 2000;

export const errorToast = (content: string, d: number = duration): void => {
  MessagePlugin.closeAll();
  message.error({
    content,
    placement: 'top',
    zIndex: 7000,
    duration: d,
  }, duration);
};

export const infoToast = (content: string, d: number = duration): void => {
  MessagePlugin.closeAll();
  message.info({
    content,
    placement: 'top',
    zIndex: 7000,
    duration: d,
  }, duration);
};

export const successToast = (content: string, d: number = duration): void => {
  MessagePlugin.closeAll();
  message.success({
    content,
    placement: 'top',
    zIndex: 7000,
    duration: d,
  }, duration);
};

export const warningToast = (content: string, d: number = duration): void => {
  MessagePlugin.closeAll();
  message.warning({
    content,
    placement: 'top',
    zIndex: 7000,
    duration: d,
  }, duration);
};
